import { LoaderComponent } from './components/loader/loader.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
//  Components
import { PaginationComponent } from './components/pagination/pagination.component';

import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { DatetimepickerComponent } from './components/datetimepicker/datetimepicker.component';
import { MultiDropdownComponent } from './components/multi-dropdown/multi-dropdown.component';
import { MultiSelectComponent } from './components/multi-select/multi-select.component';
import { MultiEditComponent } from './components/multi-edit/multi-edit.component';
import { ComboboxComponent } from './components/combobox/combobox.component';
import { ComboboxSingleSelectComponent } from './components/combobox-single-select/combobox-single-select.component';
import { DynamicDropdownComponent } from './components/dynamic-dropdown/dynamic-dropdown.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TileComponent } from './components/tile/tile.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';

import { DynamicGridComponent } from './components/dynamic-grid/dynamic-grid.component';
import { DynamicGridService } from './components/dynamic-grid/dynamic-grid.service';
import { FormComponent } from './components/form/form.component';
import { FormQuestionComponent } from './components/form/form-question.component';
import { UploaderComponent } from './components/uploader/uploader.component';
import { UploaderService } from './components/uploader/uploader.service';

import { ExpandablePanelComponent } from './components/expandable-panel/expandable-panel.component';
import { PanelDirective } from './components/expandable-panel/panel.directive';

import { ComponentDirective } from './components/modal/component.directive';
import { ModalComponent } from './components/modal/modal.component';
import { SimpleInfoComponent } from './components/modal/simple-info.component';
import { SimpleAlertComponent } from './components/modal/simple-alert.component';

import { DetailsComponent } from './components/details/details.component';
import { DetailsService } from './components/details/details.service';

import { ReactiveInputComponent } from './components/reactive-input/reactive-input.component';

import { IntervalComponent } from './components/interval/interval.component';

import { TimepickerComponent } from './components/timepicker/timepicker.component';
import { FlexibleDropdownComponent } from './components/flexible-dropdown/flexible-dropdown.component';
import { ControlsMultiSelectComponent } from './components/controls/multi-select/multi-select.component';
import { SelectComponent } from './components/controls/select/select.component';
import { DatePickerComponent } from './components/controls/date-picker/date-picker.component';
import { AutocompleteComponent } from './components/controls/autocomplete/autocomplete.component';
//  Pipes
import { ISOToDatePipe } from './pipes/iso-to-date.pipe';
import { ISOToDateUTCPipe } from './pipes/iso-to-date-utc.pipe';
import { FormatStringPipe } from './pipes/format-string.pipe';
import { FormErrorPipe } from './pipes/form-error.pipe';
import { TimestampPipe } from './pipes/timestamp-to-date.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { NestedPipe } from './pipes/nested.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { HtmlBypassPipe } from './pipes/html-bypass.pipe';
import { CurrencyPipe } from './pipes/currency.pipe';

import { DndDirective } from './components/uploader/dnd.directive';

import { RxClickDirective } from './directives/rx.directive';
import { SmartTooltipComponent } from './components/smart-tooltip/smart-tooltip.component';
import { SmartTooltipDirective } from './components/smart-tooltip/smart-tooltip.directive';

import { VideoTileComponent } from './components/video-tile/video-tile.component';
import { VimeoModalService } from './components/vimeo-modal/vimeo-modal.service';
import { VimeoModalComponent } from 'app/shared/components/vimeo-modal/vimeo-modal.component';
import { CheckboxComponent } from 'app/shared/components/controls/checkbox/checkbox.component';
import { HtmlEditorComponent } from 'app/shared/components/controls/html-editor/html-editor.component';
import { RatingComponent } from 'app/shared/components/rating/rating.component';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { ImagePreEmbedModalComponent } from './components/controls/html-editor/image-pre-embed-modal/image-pre-embed-modal.component';
import { PreviewCertificateComponent } from 'app/shared/components/preview-certificate/preview-certificate.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SilkEditorComponent } from './components/silk/silk-editor/silk-editor.component';
import { AddImageComponent } from './components/silk/toolbars/standard-toolbar/add-image/add-image.component';
import { ColorDropdownComponent } from './components/silk/toolbars/standard-toolbar/color-dropdown/color-dropdown.component';
import { FontSizeDropdownComponent } from './components/silk/toolbars/standard-toolbar/font-size-dropdown/font-size-dropdown.component';
import { LinkCreateComponent } from './components/silk/toolbars/standard-toolbar/link-create/link-create.component';
import { TableCreateComponent } from './components/silk/toolbars/standard-toolbar/table-create/table-create.component';

import { HappyCheckboxControlComponent } from './components/happy/happy-checkbox-control/happy-checkbox-control.component';
import { HappyControlGroupInputComponent } from './components/happy/happy-control-group/happy-control-group-input.component';
import { HappyDetailsGroupComponent } from './components/happy/happy-details-group/happy-details-group.component';
import { HappyDropdownComponent } from 'app/shared/components/happy/happy-dropdown/happy-dropdown.component';
import { HappyHeadingComponent } from './components/happy/happy-heading/happy-heading.component';
import { HappyListComponent } from './components/happy/happy-list/happy-list.component';
import { HappyRadioInputComponent } from './components/happy/happy-radio-input/happy-radio-input.component';
import { HappySelectInputComponent } from './components/happy/happy-select-input/happy-select-input.component';
import { HappyStepperComponent } from './components/happy/happy-stepper/happy-stepper.component';
import { HappyTextInputComponent } from './components/happy/happy-text-input/happy-text-input.component';
import { HappyTextareaInputComponent } from './components/happy/happy-textarea-input/happy-textarea-input.component';
import { HappyStepComponent } from 'app/shared/components/happy/happy-stepper/happy-step/happy-step.component';
import { HappyInputTemplateComponent } from 'app/shared/components/happy/happy-template-input/happy-input-template.component';
import { StandardToolbarComponent } from './components/silk/toolbars/standard-toolbar/standard-toolbar.component';
import { DetailsGroupComponent } from 'app/shared/components/details-group/details-group.component';
import { SelectThumbnailComponent } from './components/select-thumbnail/select-thumbnail.component';
import { MultiCheckBoxSharedComponent } from './components/multi-check-box/multi-check-box.component';
import { FilterListSharedComponent } from './components/filter-list/filter-list.component';
import { UberFilterService } from './components/uber-filter/uber-filter.service';
import { UberFilterDataService } from './components/uber-filter/uber-filter-data.service';
import { TranslateHandlebarsPipe } from './pipes/translate-handlebars.pipe';
import { ProceedDetailsComponent } from './components/settlement-proceeds-details/proceed-details.component';
import { SettlementBatchDetailsComponent } from './components/settlements-batch-details/settlement-batch-details.component';
import { SettlementDownloadCsvComponent } from './components/settlement-download-csv/settlement-download-csv.component';
import { CreateNewPricingListComponent } from './components/pricing/create-new-pricing-list/create-new-pricing-list.component';
import { CreateNewPriceComponent } from './components/pricing/create-new-price/create-new-price.component';
import { ReCaptchaDirective } from './directives/recaptcha.directive';
import { FilterSectionComponent } from './components/filter-section/filter-section.component';
import { FlexFilterSharedComponent } from './components/flex-filter/flex-filter.component';
import { FilterableGridComponent } from './components/filterable-grid/filterable-grid.component';
import { FilterColumnComponent } from './components/filterable-grid/filter-column/filter-column.component';
import { FilterBoxSharedComponent } from './components/filterable-grid/filter-group/filter-box.component';
import { SolarTooltipDirective } from './directives/solar-tooltip.directive';
import { MainStepComponent } from './components/modal/catalog-modal/steps/main-step/main-step.component';
import { CatalogModalComponent } from './components/modal/catalog-modal/catalog-modal.component';
import { LatterStepComponent } from './components/modal/catalog-modal/steps/latter-step/latter-step.component';
import { FinalStepComponent } from './components/modal/catalog-modal/steps/final-step/final-step.component';
import { CatalogTemplateHostComponent } from './components/modal/catalog-modal/catalog-template-host.component';
import { WaterfallComponent } from './components/waterfall/waterfall.component';
import { WaterfallService } from './components/waterfall/waterfall.service';
import { GlobalFilterListComponent } from './components/global-filter-list/global-filter-list.component';
import { InputRefDirective } from './directives/input-ref.directive';
import { HappyAutocompleteComponent } from './components/happy/happy-autocomplete/happy-autocomplete.component';
import { DeliveryCourseFiltersComponent } from './components/delivery-course-filters/delivery-course-filters.component';
import { FilterDaterangeComponent } from './components/filter-daterange/filter-daterange.component';
import { SimpleUploaderComponent } from './components/simple-uploader/simple-uploader.component';
import { MultitabSelectionList } from './components/multitab-selection-list/multitab-selection-list.component';
import {  ExpansionPanelComponent } from './components/expansion-panel/expansion-panel.component';
import { ToggleCheckBoxComponent } from './components/toggle-checbox/toggle-checkbox.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { PromoPricingAlertComponent } from './components/modal/promo-pricing-alert.component';

// Controls

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        PaginationComponent,
        MultiDropdownComponent,
        ComboboxComponent,
        ComboboxSingleSelectComponent,
        MultiSelectComponent,
        MultiEditComponent,
        SpinnerComponent,
        BreadcrumbsComponent,
        TileComponent,
        UploaderComponent,
        FormComponent,
        FormQuestionComponent,
        DynamicGridComponent,
        DatepickerComponent,
        DatetimepickerComponent,
        ExpandablePanelComponent,
        PanelDirective,
        ModalComponent,
        ComponentDirective,
        DetailsComponent,
        SimpleInfoComponent,
        SimpleAlertComponent,
        PromoPricingAlertComponent,
        LoaderComponent,
        DetailsGroupComponent,
        ISOToDatePipe,
        ISOToDateUTCPipe,
        FormatStringPipe,
        TimestampPipe,
        FormErrorPipe,
        HtmlBypassPipe,
        DynamicDropdownComponent,
        SafeUrlPipe,
        WaterfallComponent,
        DndDirective,
        RxClickDirective,
        ReactiveInputComponent,
        TranslatePipe,
        TranslateHandlebarsPipe,
        CurrencyPipe,
        NestedPipe,
        EllipsisPipe,
        IntervalComponent,
        TimepickerComponent,
        SmartTooltipComponent,
        // Controls
        ControlsMultiSelectComponent,
        SelectComponent,

        FlexibleDropdownComponent,
        SmartTooltipDirective,
        SolarTooltipDirective,
        VideoTileComponent,
        VimeoModalComponent,
        DatePickerComponent,
        AutocompleteComponent,
        CheckboxComponent,
        HtmlEditorComponent,
        RatingComponent,
        NumberOnlyDirective,
        ImagePreEmbedModalComponent,
        PreviewCertificateComponent,
        SilkEditorComponent,
        StandardToolbarComponent,
        AddImageComponent,
        ColorDropdownComponent,
        FontSizeDropdownComponent,
        LinkCreateComponent,
        TableCreateComponent,
        SelectThumbnailComponent,

        HappyCheckboxControlComponent,
        HappyControlGroupInputComponent,
        HappyDetailsGroupComponent,
        HappyDropdownComponent,
        HappyHeadingComponent,
        HappyListComponent,
        HappyRadioInputComponent,
        HappySelectInputComponent,
        HappyStepperComponent,
        HappyStepComponent,
        HappyTextInputComponent,
        HappyTextareaInputComponent,
        HappyInputTemplateComponent,

        MultiCheckBoxSharedComponent,
        FilterListSharedComponent,
        ProceedDetailsComponent,
        SettlementBatchDetailsComponent,
        SettlementDownloadCsvComponent,

        CreateNewPricingListComponent,
        CreateNewPriceComponent,
        ReCaptchaDirective,

        FilterSectionComponent,

        // Solar components
        FlexFilterSharedComponent,
        FilterableGridComponent,
        FilterColumnComponent,
        FilterBoxSharedComponent,
        CatalogModalComponent,
        MainStepComponent,
        LatterStepComponent,
        FinalStepComponent,
        CatalogTemplateHostComponent,
        GlobalFilterListComponent,
        CatalogTemplateHostComponent,
        InputRefDirective,
        HappyAutocompleteComponent,
        FilterDaterangeComponent,
        HappyAutocompleteComponent,
        DeliveryCourseFiltersComponent,
        SimpleUploaderComponent,

        MultitabSelectionList,
        ExpansionPanelComponent,
        ToggleCheckBoxComponent,
        TooltipComponent
    ],
    providers: [
        UploaderService,
        DynamicGridService,
        DetailsService,
        TranslatePipe,
        TranslateHandlebarsPipe,
        HtmlBypassPipe,
        VimeoModalService,
        CurrencyPipe,
        UberFilterService,
        UberFilterDataService,
        WaterfallService
    ],
    exports: [
        PaginationComponent,
        MultiDropdownComponent,
        ComboboxComponent,
        ComboboxSingleSelectComponent,
        MultiSelectComponent,
        MultiEditComponent,
        SpinnerComponent,
        BreadcrumbsComponent,
        TileComponent,
        UploaderComponent,
        FormComponent,
        DynamicGridComponent,
        DatepickerComponent,
        DatetimepickerComponent,
        ExpandablePanelComponent,
        ModalComponent,
        DetailsComponent,
        ReactiveInputComponent,
        RxClickDirective,
        IntervalComponent,
        LoaderComponent,
        TimepickerComponent,
        SmartTooltipComponent,
        ControlsMultiSelectComponent,
        SelectComponent,
        DatePickerComponent,
        AutocompleteComponent,
        DetailsGroupComponent,
        FlexibleDropdownComponent,
        SmartTooltipDirective,
        SolarTooltipDirective,
        VimeoModalComponent,
        VideoTileComponent,
        HtmlEditorComponent,
        SilkEditorComponent,
        StandardToolbarComponent,
        SelectThumbnailComponent,
        CatalogTemplateHostComponent,
        WaterfallComponent,
        ISOToDatePipe,
        ISOToDateUTCPipe,
        FormatStringPipe,
        TimestampPipe,
        FormErrorPipe,
        TranslatePipe,
        TranslateHandlebarsPipe,
        CurrencyPipe,
        NestedPipe,
        EllipsisPipe,
        HtmlBypassPipe,
        CheckboxComponent,
        RatingComponent,
        SafeUrlPipe,
        HappyStepComponent,
        HappyCheckboxControlComponent,
        HappyControlGroupInputComponent,
        HappyDetailsGroupComponent,
        HappyDropdownComponent,
        HappyHeadingComponent,
        HappyListComponent,
        HappyRadioInputComponent,
        HappySelectInputComponent,
        HappyStepperComponent,
        HappyStepComponent,
        HappyTextInputComponent,
        HappyTextareaInputComponent,
        HappyInputTemplateComponent,
        FilterListSharedComponent,
        MultiCheckBoxSharedComponent,
        ProceedDetailsComponent,
        SettlementBatchDetailsComponent,
        SettlementDownloadCsvComponent,
        CreateNewPricingListComponent,
        CreateNewPriceComponent,
        DeliveryCourseFiltersComponent,
        SimpleUploaderComponent,
        NumberOnlyDirective,

        ReCaptchaDirective,
        FilterSectionComponent,

        // Solar components
        FlexFilterSharedComponent,
        FilterableGridComponent,
        FilterColumnComponent,
        FilterBoxSharedComponent,
        GlobalFilterListComponent,
        FilterBoxSharedComponent,
        HappyAutocompleteComponent,
        FilterDaterangeComponent,

        MultitabSelectionList,
        ExpansionPanelComponent,
        ToggleCheckBoxComponent,
        TooltipComponent
    ],
    entryComponents: [
        SimpleInfoComponent,
        SimpleAlertComponent,
        PromoPricingAlertComponent,
        VimeoModalComponent,
        ImagePreEmbedModalComponent,
        AddImageComponent,
        ProceedDetailsComponent,
        SettlementDownloadCsvComponent,
        CreateNewPricingListComponent,
        CreateNewPriceComponent,
        CatalogModalComponent,
        CatalogTemplateHostComponent,
        WaterfallComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts